










































































































import { Component, Vue } from "vue-property-decorator";
import DadosPlaca from "@/components/dados/DadosPlaca.vue";
import DadosVersao from "@/components/dados/DadosVersao.vue";
import DadosCepComplemento from "@/components/dados/DadosCepComplemento.vue";
import DadosProsseguir from "@/components/dados/DadosProsseguir.vue";
import DadosEstadoComplemento from "@/components/dados/DadosEstadoComplemento.vue";
import DadosCidadeComplemento from "@/components/dados/DadosCidadeComplemento.vue";
import DadosLogradouroComplemento from "@/components/dados/DadosLogradouroComplemento.vue";
import DadosBairroComplemento from "@/components/dados/DadosBairroComplemento.vue";
import DadosComplementoComplemento from "@/components/dados/DadosComplementoComplemento.vue";
import axios from 'axios';
@Component({
    components: {
        DadosPlaca,
        DadosVersao,
        DadosCepComplemento,
        DadosProsseguir,
        DadosEstadoComplemento,
        DadosCidadeComplemento,
        DadosLogradouroComplemento,
        DadosBairroComplemento,
        DadosComplementoComplemento
    }
})
export default class Complemento extends Vue {

    public versao = "";
    public result = [];

    get valor_fipe () {
        return this.$store.state.placa.valor_fipe;
    }

    set valor_fipe ( value ) {
        this.$store.commit("SET_VALOR_FIPE", value);
    }

    get combustivel () {
        return this.$store.state.placa.combustivel;
    }

    set combustivel ( value ) {
        this.$store.commit("SET_COMBUSTIVEL", value);
    }

    get placa () {
        return this.$store.state.placa.placa;
    }

    set placa ( value ) {
        this.$store.commit("SET_PLACA", value);
    }

    get ano () {
        return this.$store.state.placa.ano;
    }

    set ano ( value ) {
        this.$store.commit("SET_ANO", value);
    }

    get modelo () {
        return this.$store.state.placa.modelo;
    }

    set modelo ( value ) {
        this.$store.commit("SET_MODELO", value);
    }

    get marca () {
        return this.$store.state.placa.marca;
    }

    set marca ( value ) {
        this.$store.commit("SET_MARCA", value);
    }

    get versaoSelecionada () {
        return this.$store.state.placa.versaoSelecionada;
    }

    set versaoSelecionada ( value ) {
        this.$store.commit("SET_VERSAOSELECIONADA", value);
    }

    public searchFipe() {
      axios.get(`http://api.fipeapi.com.br/v1/fipe/${this.versaoSelecionada}?81c3491bd83d67d9ad889cca166ea3d9`)
      .then( (response) => {
          this.result = response.data[0].tipo,
          this.valor_fipe = response.data[0].preco,
          this.marca = response.data[0].marca
      }).catch((error) => console.log(error));
    }

    public mounted () {
        this.$store.commit('SET_SIDEBAR_SHOWING', false);
        this.$store.commit('SET_SIDEBAR_ENABLED', false);

        const query = this.$route.query as {ref: string, fipe: string, ano: string};
        if ( query.fipe !== undefined && query.ano !== undefined ) {
            this.$store.dispatch('FROM_COD_ANO', query).then();
        }
    }

    get origemFipe () {
        return this.$store.state.origem_fipe;
    }

  public searchPlaca () {
    if(this.placa.length >= 6){
        axios.get(`https://api.wipsites.com.br/dados/placa/${ this.placa }`)
        .then( (response) => {
            this.versao = response.data.fipes,
            this.marca = response.data.dados_do_veiculo.marca_modelo,
            this.marca = this.marca.substring(0, this.marca.lastIndexOf("/")),
            this.ano = response.data.dados_do_veiculo.ano,
            this.combustivel = response.data.dados_do_veiculo.combustivel,
            this.modelo = response.data.dados_do_veiculo.marca_modelo,
            this.modelo = this.modelo.substring(this.modelo.indexOf("/") + 1);

        }).catch( error => console.log(error) )
    }
  }

    public onClick () {

        this.$router.push({
          name: 'detalhes'
        });


    }
}
